module.exports = __webpack_public_path__ + "img/surya-kandel.f498868f.jpg";